import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function Profile() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('info');

  const studentInfo = {
    name: 'أحمد محمد العلي',
    studentId: 'STU-2024-001',
    email: 'ahmed.ali@example.com',
    phone: '0501234567',
    department: 'كلية العلوم',
    major: 'الرياضيات',
    level: 'المستوى الرابع',
    gpa: 3.85,
    joinDate: '2021-09-01'
  };

  const achievements = [
    { icon: 'ri-trophy-line', title: 'الطالب المتفوق', description: 'حصلت على أعلى معدل في الفصل الدراسي', color: 'bg-yellow-500' },
    { icon: 'ri-medal-line', title: 'إنجاز 50 اختبار', description: 'أكملت 50 اختباراً بنجاح', color: 'bg-blue-500' },
    { icon: 'ri-star-line', title: 'متوسط ممتاز', description: 'حافظت على معدل أعلى من 85%', color: 'bg-purple-500' },
    { icon: 'ri-fire-line', title: 'سلسلة 30 يوم', description: 'دخلت المنصة لمدة 30 يوماً متتالياً', color: 'bg-orange-500' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Profile Header */}
        <div className="bg-gradient-to-r from-[#0F2A3A] to-[#1a3d52] rounded-2xl p-8 mb-8 text-white">
          <div className="flex items-center gap-6">
            <div className="w-24 h-24 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full text-5xl font-bold">
              {studentInfo.name.charAt(0)}
            </div>
            <div className="flex-1">
              <h1 className="text-3xl font-bold mb-2">{studentInfo.name}</h1>
              <p className="text-white/80 text-lg mb-3">{studentInfo.studentId}</p>
              <div className="flex items-center gap-4">
                <span className="px-4 py-2 bg-white/20 rounded-full text-sm">{studentInfo.department}</span>
                <span className="px-4 py-2 bg-white/20 rounded-full text-sm">{studentInfo.major}</span>
                <span className="px-4 py-2 bg-white/20 rounded-full text-sm">{studentInfo.level}</span>
              </div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">{studentInfo.gpa}</div>
              <p className="text-white/80">المعدل التراكمي</p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-lg p-2 mb-8 inline-flex gap-2">
          <button
            onClick={() => setActiveTab('info')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'info' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-user-line ml-2"></i>
            المعلومات الشخصية
          </button>
          <button
            onClick={() => setActiveTab('achievements')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'achievements' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-trophy-line ml-2"></i>
            الإنجازات
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              activeTab === 'settings' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            <i className="ri-settings-line ml-2"></i>
            الإعدادات
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'info' && (
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">البيانات الأساسية</h2>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <span className="text-slate-600">الاسم الكامل</span>
                  <span className="font-semibold text-[#0F2A3A]">{studentInfo.name}</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <span className="text-slate-600">الرقم الجامعي</span>
                  <span className="font-semibold text-[#0F2A3A]">{studentInfo.studentId}</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <span className="text-slate-600">البريد الإلكتروني</span>
                  <span className="font-semibold text-[#0F2A3A]">{studentInfo.email}</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <span className="text-slate-600">رقم الجوال</span>
                  <span className="font-semibold text-[#0F2A3A]">{studentInfo.phone}</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <span className="text-slate-600">تاريخ الالتحاق</span>
                  <span className="font-semibold text-[#0F2A3A]">{studentInfo.joinDate}</span>
                </div>
              </div>
              <button className="w-full mt-6 py-3 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-edit-line ml-2"></i>
                تعديل البيانات
              </button>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">الإحصائيات الأكاديمية</h2>
              <div className="space-y-6">
                <div className="p-6 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl text-white">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white/80">إجمالي الاختبارات</span>
                    <i className="ri-file-list-3-line text-3xl"></i>
                  </div>
                  <p className="text-4xl font-bold">24</p>
                </div>

                <div className="p-6 bg-gradient-to-r from-green-500 to-green-600 rounded-xl text-white">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white/80">متوسط الدرجات</span>
                    <i className="ri-percent-line text-3xl"></i>
                  </div>
                  <p className="text-4xl font-bold">85%</p>
                </div>

                <div className="p-6 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl text-white">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-white/80">الترتيب العام</span>
                    <i className="ri-trophy-line text-3xl"></i>
                  </div>
                  <p className="text-4xl font-bold">12 من 150</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'achievements' && (
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">الإنجازات والشارات</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {achievements.map((achievement, index) => (
                <div key={index} className="flex items-start gap-4 p-6 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
                  <div className={`w-16 h-16 flex items-center justify-center ${achievement.color} rounded-xl flex-shrink-0`}>
                    <i className={`${achievement.icon} text-3xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0F2A3A] mb-2">{achievement.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{achievement.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">الإعدادات العامة</h2>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-[#0F2A3A] mb-1">الإشعارات</p>
                    <p className="text-sm text-slate-600">تلقي إشعارات الاختبارات</p>
                  </div>
                  <label className="relative inline-block w-12 h-6 cursor-pointer">
                    <input type="checkbox" className="sr-only peer" defaultChecked />
                    <div className="w-12 h-6 bg-slate-300 rounded-full peer-checked:bg-[#1ABC9C] transition-colors"></div>
                    <div className="absolute top-0.5 right-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-6"></div>
                  </label>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-[#0F2A3A] mb-1">البريد الإلكتروني</p>
                    <p className="text-sm text-slate-600">إرسال النتائج عبر البريد</p>
                  </div>
                  <label className="relative inline-block w-12 h-6 cursor-pointer">
                    <input type="checkbox" className="sr-only peer" defaultChecked />
                    <div className="w-12 h-6 bg-slate-300 rounded-full peer-checked:bg-[#1ABC9C] transition-colors"></div>
                    <div className="absolute top-0.5 right-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-6"></div>
                  </label>
                </div>

                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-[#0F2A3A] mb-1">الوضع الداكن</p>
                    <p className="text-sm text-slate-600">تفعيل الوضع الليلي</p>
                  </div>
                  <label className="relative inline-block w-12 h-6 cursor-pointer">
                    <input type="checkbox" className="sr-only peer" />
                    <div className="w-12 h-6 bg-slate-300 rounded-full peer-checked:bg-[#1ABC9C] transition-colors"></div>
                    <div className="absolute top-0.5 right-0.5 w-5 h-5 bg-white rounded-full transition-transform peer-checked:translate-x-6"></div>
                  </label>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">الأمان والخصوصية</h2>
              <div className="space-y-4">
                <button className="w-full p-4 bg-slate-50 rounded-xl text-right hover:bg-slate-100 transition-colors cursor-pointer">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <i className="ri-lock-line text-2xl text-[#1ABC9C]"></i>
                      <span className="font-semibold text-[#0F2A3A]">تغيير كلمة المرور</span>
                    </div>
                    <i className="ri-arrow-left-line text-slate-400"></i>
                  </div>
                </button>

                <button className="w-full p-4 bg-slate-50 rounded-xl text-right hover:bg-slate-100 transition-colors cursor-pointer">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <i className="ri-shield-check-line text-2xl text-[#1ABC9C]"></i>
                      <span className="font-semibold text-[#0F2A3A]">المصادقة الثنائية</span>
                    </div>
                    <i className="ri-arrow-left-line text-slate-400"></i>
                  </div>
                </button>

                <button className="w-full p-4 bg-slate-50 rounded-xl text-right hover:bg-slate-100 transition-colors cursor-pointer">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <i className="ri-file-text-line text-2xl text-[#1ABC9C]"></i>
                      <span className="font-semibold text-[#0F2A3A]">سياسة الخصوصية</span>
                    </div>
                    <i className="ri-arrow-left-line text-slate-400"></i>
                  </div>
                </button>

                <button
                  onClick={() => navigate('/welcome')}
                  className="w-full p-4 bg-red-50 rounded-xl text-right hover:bg-red-100 transition-colors cursor-pointer"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <i className="ri-logout-box-line text-2xl text-red-600"></i>
                      <span className="font-semibold text-red-600">تسجيل الخروج</span>
                    </div>
                    <i className="ri-arrow-left-line text-red-400"></i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
